// Dependencies
import { PropsWithChildren, createContext, useEffect, useRef } from 'react'
import LogRocket from "logrocket"

// Providers
import { useAuth0 } from '@auth0/auth0-react'
import { useUserMsp } from '../hooks/useUserMsp'
import { isHorizonRootRole } from '../utils/horizonRoles'

const LogRocketContext = createContext({})

export const LogRocketProvider = ({ children }: PropsWithChildren) => {
  return (
    <LogRocketContext.Provider value={{}}>
      {children}
      <LogRocketComponent />
    </LogRocketContext.Provider>
  );
};

const LogRocketComponent = () => {
  const { user, isAuthenticated } = useAuth0()
  const { userMspInfo } = useUserMsp()
  const logCount = useRef(0)
  const isRootUser = isHorizonRootRole(userMspInfo?.role)
  const isProdOrigin =
    typeof window !== "undefined" &&
    window.location.origin === "https://runtheo.app"

  useEffect(() => {
    if (
      isProdOrigin &&
      isAuthenticated &&
      !isRootUser &&
      user &&
      user.sub &&
      logCount.current < 1
    ) {
      logCount.current = logCount.current + 1

      LogRocket.init("n3fxur/theo")

      // Identify the user
      LogRocket.identify(user.sub, {
        name: user.name || user.email || 'Unknown User',
        email: user.email || 'unknown@example.com',
        // Add any additional user properties you want to track
        auth0_sub: user.sub,
        auth0_nickname: user.nickname || 'No Nickname',
      })

      // Get session URL for backend logging if needed
      LogRocket.getSessionURL(() => {
        // TODO: Add session logging to your backend API if needed
        // logSession(sessionURL)
      })
    }
  }, [user, isAuthenticated, isRootUser, isProdOrigin])

  // Render empty section to not affect the UI
  return <></>
}
